<!--
 * @Description: 登录组件
 * @Author: hai-27
 * @Date: 2020-02-19 20:55:17
 * @LastEditors: hai-27
 * @LastEditTime: 2020-03-01 15:34:08
 -->
<template>
  <div id="myLogin">
    <el-dialog title="登录" width="300px" center :visible.sync="isLogin">
      <el-form :model="LoginUser" :rules="rules" status-icon ref="ruleForm" class="demo-ruleForm">
        <el-form-item prop="name">
          <el-input prefix-icon="el-icon-user-solid" placeholder="请输入账号" v-model="LoginUser.name"></el-input>
        </el-form-item>
        <el-form-item prop="pass">
          <el-input
            prefix-icon="el-icon-view"
            type="password"
            placeholder="请输入密码"
            v-model="LoginUser.pass"
            @keyup.enter.native="Login"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" type="primary" @click="Login" style="width:100%;">登录</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import store from '@/store'
import { setToken } from '@/utils/auth'
export default {
  name: 'MyLogin',
  data () {
    return {
      LoginUser: {
        name: '',
        pass: ''
      },
      // 用户信息校验规则,validator(校验方法),trigger(触发方式),blur为在组件 Input 失去焦点时触发
      rules: {
        name: [{ required: true, message: '用戶名不能为空', trigger: 'blur' }],
        pass: [{ required: true, message: '密码不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    // 获取vuex中的showLogin，控制登录组件是否显示
    isLogin: {
      get () {
        return this.$store.getters.getShowLogin
      },
      set (val) {
        this.$refs['ruleForm'].resetFields()
        this.setShowLogin(val)
      }
    }
  },
  methods: {
    ...mapActions(['setToken', 'setUser', 'setShowLogin']),
    getMailList () {
      var p = 1
      this.$axios({
        url: '/article/list/page',
        method: 'get',
        params: {
          page: p,
          readStatus: 0
        }
      }).then((response) => {
        this.totalPage = response.data.totalElements
        if (response.data.status === 200) {
          store.dispatch('setMailCount', response.data.totalElements)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    getUserInfo () {
      this.$axios
        .get('/userinfo')
        .then(res => {
          // “001”代表登录成功，其他的均为失败
          console.log(res)
          if (res.data.status === 200) {
            // this.setUser(res.data.data)
            store.dispatch('setUser', res.data.data)
          } else {
          }
        })
        .catch(err => {
          return Promise.reject(err)
        })
    },
    Login () {
      // 通过element自定义表单校验规则，校验用户输入的用户信息
      this.$refs['ruleForm'].validate((valid) => {
        // 如果通过校验开始登录
        console.log(valid)
        if (valid) {
          /* store.dispatch('Login', {
            username: this.LoginUser.name,
            password: this.LoginUser.pass
          }).then(() => {
            // 隐藏登录组件
            this.isLogin = false
            // 弹出通知框提示登录成功信息
            this.$message({
              type: 'success',
              message: '登录成功'
            })
          }) */
          this.$axios
            .post('/login', {
              username: this.LoginUser.name,
              password: this.LoginUser.pass
            })
            .then(res => {
              // “001”代表登录成功，其他的均为失败
              console.log(res)
              if (res.data.status === 200) {
                // 隐藏登录组件
                this.isLogin = false
                // 登录信息存到本地
                // let user = JSON.stringify(res.data.user)
                // localStorage.setItem('user', user)
                // 登录信息存到vuex
                setToken('Bearer ' + res.data.data.token)
                this.setToken('Bearer ' + res.data.data.token)
                // store.dispatch('GetInfo').then(() => {})
                this.getUserInfo()
                this.getMailList()
                // 弹出通知框提示登录成功信息
                this.$message({
                  type: 'success',
                  message: res.data.msg
                })
                location.reload()
              } else {
                // 清空输入框的校验状态
                this.$refs['ruleForm'].resetFields()
                // 弹出通知框提示登录失败信息
                this.$message({
                  type: 'error',
                  message: res.data.msg
                })
              }
            })
            .catch(err => {
              return Promise.reject(err)
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/login/MyLogin.vue